import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {environment} from "environments/environment";
import {DefaultImage, DefaultImagePositionTypeEnum, DefaultImageRequestDto} from "app/models/defaultImage.model";

@Injectable({
  providedIn: 'root'
})
export class DefaultImageApiService {
  private requestPath = `${environment.posBaseUrl}/api/front/default-images`;
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private http: HttpClient,
  ) {}

  async getDefaultImagesAsync(organizationId: string): Promise<DefaultImage[]> {
    try {
      const response = await firstValueFrom(
        this.http.get<DefaultImage[]>(
          this.requestPath + '/' + organizationId,
        )
      );
      return response ?? [];
    } catch (exception) {
      console.error('Failed to get default images:', exception);
      throw exception;
    }
  }

  async updateDefaultImageAsync(
    organizationId: string,
    positionType: DefaultImagePositionTypeEnum,
    requestBody: DefaultImageRequestDto,
  ): Promise<void> {
    try {
      await firstValueFrom(
        this.http.put<null>(
          this.requestPath + '/' + organizationId + '/' + positionType,
          requestBody,
          {
            headers: this.headers,
          }
        )
      );
    } catch (exception) {
      console.error('Failed to update default image:', exception);
      throw exception;
    }
  }

  /** Сброс к нашей стандартной картинке. */
  async resetDefaultImageAsync(organizationId: string, positionType: DefaultImagePositionTypeEnum): Promise<void> {
    try {
      await firstValueFrom(
        this.http.delete<null>(
          this.requestPath + '/' + organizationId + '/' + positionType,
        )
      );
    } catch (exception) {
      console.error('Failed to reset default image:', exception);
      throw exception;
    }
  }
}
